import type { CanMatchFn } from '@angular/router';

/**
 * Guard funcional de tipo de workflow. Verifica que el primer segmento de la ruta corresponda
 * a un tipo de adquisición válido (`adquisicion-indicativa` o `adquisicion-ejecutada`) y persiste
 * el slug del tipo en una cookie `workflowTypeSlug` para su uso posterior.
 * Redirige a `/configuration/workflow` si el segmento no es reconocido.
 */
export const workflowTypeGuard: CanMatchFn = (route, segments) => {
  const typeSegment = segments[0]?.path;
  if (!typeSegment) {
    return false;
  }
  switch (typeSegment) {
    case 'adquisicion-indicativa':
      document.cookie = `workflowTypeSlug=procurement_indicative_workflow; path=/`;
      return true;
    case 'adquisicion-ejecutada':
      document.cookie = `workflowTypeSlug=procurement_executed_workflow; path=/`;
      return true;
    default:
      globalThis.location.pathname = '/configuration/workflow';
      return false;
  }
};
